<div *ngIf="model">
  <div class="card">
    <div class="card-body">
      <!--
        Süzgeç araç çubuğu (e-fatura listesiyle aynı düzen): tutar araması dışarıda,
        diğer süzgeçler "Filtreler" panelinde. Seçimler anında uygulanır; panel
        dışına tıklamadıkça açık kalır.
      -->
      <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-3" *ngIf="hasAnyFilterArea()">
        <span class="text-muted small" *ngIf="model.data">{{ model.data.TotalItemCount || 0 }} hareket</span>
        <div class="d-flex gap-2 ms-auto">
          <input *ngIf="pageFilterAreas.amount" type="number" class="form-control" placeholder="Tutar ara" style="max-width: 180px"
            [(ngModel)]="request.filter.amount" (ngModelChange)="scheduleFilter()" (keydown.enter)="applyFilterNow()">
          <div ngbDropdown #filterDropdown="ngbDropdown" autoClose="outside" placement="bottom-right" *ngIf="hasPanelFilterArea()">
            <button type="button" class="btn btn-light" ngbDropdownToggle>
              <i class="bx bx-filter-alt me-1"></i>Filtreler
              <span class="badge bg-primary ms-1" *ngIf="panelFilterCount()">{{ panelFilterCount() }}</span>
              <i class="mdi mdi-chevron-down ms-1"></i>
            </button>
            <div ngbDropdownMenu class="dropdown-menu-end p-3" style="width: 320px;">
              <div class="mb-2" *ngIf="pageFilterAreas.currency">
                <label class="form-label">Birim</label>
                <select class="form-select" [(ngModel)]="request.filter.currency" (change)="currencyChanged()">
                  <option [ngValue]="defaultValue">Tümü</option>
                  <option *ngFor="let currency of currencyList" [ngValue]="currency"> {{currency | customCurrency}} </option>
                </select>
              </div>
              <div class="mb-2" *ngIf="pageFilterAreas.subType && subTypeList?.length > 0">
                <label class="form-label">Alt Birim</label>
                <select class="form-select" [(ngModel)]="request.filter.subType" (change)="reloadData(true)">
                  <option [ngValue]="defaultValue">Tümü</option>
                  <option *ngFor="let subType of subTypeList" [ngValue]="subType"> {{subType | subTypeDisplay}} </option>
                </select>
              </div>
              <div class="mb-2" *ngIf="pageFilterAreas.case">
                <label class="form-label">Kasa</label>
                <select class="form-select" [(ngModel)]="request.filter.caseId" (ngModelChange)="reloadData(true)">
                  <option [ngValue]="null">Tümü</option>
                  <option *ngFor="let item of branchCases" [value]="item.value">{{item.text}} </option>
                </select>
              </div>
              <div class="mb-2" *ngIf="pageFilterAreas.state">
                <label class="form-label">Durum</label>
                <select class="form-select" [(ngModel)]="request.filter.type" (change)="reloadData(true)">
                  <option [ngValue]="defaultValue">Tümü</option>
                  <option *ngFor="let item of accountTransactionTypes" [ngValue]="item">{{item | transactionTypeText}}</option>
                </select>
              </div>
              <div class="mb-2" *ngIf="pageFilterAreas.expenses">
                <label class="form-label">Masraf</label>
                <select class="form-select" [(ngModel)]="request.filter.expenseTypeId" (ngModelChange)="reloadData(true)">
                  <option [ngValue]="null">Tümü</option>
                  <option *ngFor="let item of expenseList" [value]="item.value">{{item.text}} </option>
                </select>
              </div>
              <div class="mb-2" *ngIf="pageFilterAreas.creater">
                <label class="form-label">İşlemi Yapan</label>
                <select class="form-select" [(ngModel)]="request.filter.createrId" (change)="reloadData(true)">
                  <option [ngValue]="defaultValue">Tümü</option>
                  <option *ngFor="let item of applicationUsers" [value]="item.value">{{item.text}}</option>
                </select>
              </div>
              <div class="mb-3" *ngIf="pageFilterAreas.startDate || pageFilterAreas.endDate">
                <label class="form-label">Tarih Aralığı</label>
                <app-date-range-filter [(start)]="beginDateModel" [(end)]="endDateModel"
                  (rangeChange)="reloadData(true)"></app-date-range-filter>
              </div>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-primary flex-grow-1"
                  (click)="applyFilterNow(); filterDropdown.close()">Filtrele</button>
                <button type="button" class="btn btn-outline-secondary" *ngIf="pageFilterAreas.clearAll"
                  (click)="clearFilter()" title="Temizle">
                  <i class="bx bx-x"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <list-spinner class="center-body" [ngClass]="{'position-absolute': model.data.Items.length > 0}"
          [showSpinner]="Loading" [length]="model.data.Items.length"></list-spinner>
        <div class="table-responsive" *ngIf="model.data && model.data.Items.length > 0"
          [ngClass]="{'blur-content': Loading}">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th class="text-center">Bilgi</th>
                <th class="text-center" *ngIf="showSelectionField">Seçim Yap</th>
                <th class="text-center" *ngIf="showBalanceField">Bakiye</th>
                <th>Tutar</th>
                <th>Birim</th>
                <th>Milyem</th>
                <th *ngIf="showCaseField">Kasa</th>
                <!-- <th>Tipi</th> -->
                <th>Oluşt. Nedeni</th>
                <th>Tarih</th>
                <th class="text-center">Geçmiş</th>
                <th class="text-center"></th>
                <th class="text-center" *hasRole="[Role.Admin, Role.SuperAdmin]">İşlem</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of model.data.Items; let index = index">
                <!--Shared popover-->
                <ng-template #popDescription><span> {{item.description}} </span></ng-template>
                <!-- Sebep başına ayrı <td> yerine tek hücre: karşılığı olmayan bir sebep
                     geldiğinde hücre hiç basılmıyor ve satırın tamamı bir sütun kayıyordu -->
                <td class="text-center text-muted">
                <ng-container *ngIf="item.reason == reasonEnum.BankAccountTransaction">
                  <i [ngbPopover]="popBankTransfer" container="body" popoverTitle="Banka Transferi" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                    <ng-template #popBankTransfer>
                      <div class="m-1 fs-6" *ngIf="item.bankAccountId != null">
                        <span class="fw-bold fs-6 me-1"> Banka Hesabı: </span> <a href="javascript: void(0)"
                          routerLink="/bank-account/detail/{{ item.bankAccountId }}"> {{ item.bankAccountName }} </a>
                      </div>
                      <div class="m-1 fs-6">
                        <span class="fw-bold fs-6 me-1"> İşlem Açıklaması: </span> <span> {{item.description}} </span>
                      </div>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.Virman">
                  <i [ngbPopover]="popDescription" container="body" popoverTitle="Virman" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                    
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.BranchTransfer">
                  <i [ngbPopover]="popDescription" container="body" popoverTitle="Açıklama" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.Deposit || item.reason == reasonEnum.Withdraw">
                  <i [ngbPopover]="popDescription" container="body" popoverTitle="Açıklama" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.BranchMoneyExit">
                  <i [ngbPopover]="popExpense" container="body" popoverTitle="Açıklama" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                  <ng-template #popExpense>
                    <span><strong class="me-2">Masraf Türü:</strong><span *ngIf="item.expenseTypeName">
                        {{item.expenseTypeName}}</span><span *ngIf="!item.expenseTypeName">Seçilmedi.</span> </span>
                    <ng-container *ngIf="item.description">
                      <br>
                      <span>{{item.description}} </span>
                    </ng-container>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.BranchMoneyEntry">
                  <i [ngbPopover]="popExpense" container="body" popoverTitle="Açıklama" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                  <ng-template #popExpense>
                    <span> <strong class="me-2">Gelir Türü:</strong><span
                        *ngIf="item.expenseTypeName">{{item.expenseTypeName}}</span><span
                        *ngIf="!item.expenseTypeName">Seçilmedi.</span></span>
                    <ng-container *ngIf="item.description">
                      <br>
                      <span>{{item.description}} </span>
                    </ng-container>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.ProductionCost || item.reason == reasonEnum.RawMaterialPurchase || item.reason == reasonEnum.ProductPurchase">
                  <i [ngbPopover]="popCostPurchase" container="body" popoverTitle="Müşteri" placement="top"
                    class="fas fa-info-circle fa-2xl" *ngIf="item.customerId"></i>
                  <i [ngbPopover]="popCostPurchaseWithGetCustomer" container="body" popoverTitle="Müşteri"
                    placement="top" class="fas fa-info-circle fa-2xl" (click)="getCustomerByGroupId(item.groupId)"
                    *ngIf="!item.customerId"></i>
                  <ng-template #popCostPurchase>
                    <a href="javascript: void(0)" routerLink="/customer/detail/{{ item.customerId }}">
                      {{item.customerName}} </a>
                  </ng-template>
                  <ng-template #popCostPurchaseWithGetCustomer>
                    <a *ngIf="customerOfDetail" href="javascript: void(0)"
                      routerLink="/customer/detail/{{ customerOfDetail.id }}"> {{customerOfDetail.displayName}} </a>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.ProductTransfer">
                  <i [ngbPopover]="popProductTransfer" container="body" popoverTitle="Ürüne Aktarım" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                  <ng-template #popProductTransfer>
                    <div class="m-1 fs-6" *ngIf="item.productId">
                      <span class="fw-bold fs-6 me-1"> Ürün: </span> <a href="javascript: void(0)"
                        routerLink="/retail/product/detail/{{ item.productId }}"> {{ item.productCode || ('#' + item.productId) }} </a>
                    </div>
                    <div class="m-1 fs-6" *ngIf="item.preProductId">
                      <span class="fw-bold fs-6 me-1"> Ara Mamül: </span> <a href="javascript: void(0)"
                        routerLink="/manufacture/pre-product/detail/{{ item.preProductId }}"> {{ item.preProductCode || ('#' + item.preProductId) }} </a>
                    </div>
                    <div class="m-1" *ngIf="!item.productId && !item.preProductId">
                      <span>{{ item.description }}</span>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.BulkPurchase">
                  <i [ngbPopover]="popBulkPurchase" container="body" popoverTitle="Mal Girişi" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                  <ng-template #popBulkPurchase>
                    <div class="m-1 fs-6" *ngIf="item.bulkPurchaseId">
                      <span class="fw-bold fs-6 me-1"> Alım: </span> <a href="javascript: void(0)"
                        routerLink="/retail/bulk-purchase/detail/{{ item.bulkPurchaseId }}"> #{{ item.bulkPurchaseId }} </a>
                    </div>
                    <div class="m-1 fs-6" *ngIf="item.customerId">
                      <span class="fw-bold fs-6 me-1"> Toptancı: </span> <a href="javascript: void(0)"
                        routerLink="/customer/detail/{{ item.customerId }}"> {{ item.customerName }} </a>
                    </div>
                    <div class="m-1 fs-6" *ngIf="item.bulkPurchaseGroupTitle">
                      <span class="fw-bold fs-6 me-1"> Grup: </span> <span> {{ item.bulkPurchaseGroupTitle }} </span>
                    </div>
                    <div class="m-1 fs-6" *ngIf="item.bulkPurchaseIsLabor && (item.bulkPurchaseLaborMilyem != null || item.bulkPurchaseLaborPerGram != null)">
                      <span class="fw-bold fs-6 me-1"> İşçilik (gram başına): </span>
                      <span *ngIf="item.bulkPurchaseLaborPerGram != null"> {{ item.bulkPurchaseLaborPerGram | number:'1.2-2' }} {{ item.currency | customCurrency }} </span>
                      <span *ngIf="item.bulkPurchaseLaborMilyem != null">
                        <ng-container *ngIf="item.bulkPurchaseLaborPerGram != null">≈ </ng-container>{{ item.bulkPurchaseLaborMilyem | number:'1.0-2' }} milyem
                        <small class="text-muted" *ngIf="item.bulkPurchaseLaborMilyemByRate">(alım günü kuruyla)</small>
                      </span>
                    </div>
                    <div class="m-1 fs-6" *ngIf="item.description">
                      <span class="fw-bold fs-6 me-1"> Açıklama: </span> <span> {{ item.description }} </span>
                    </div>
                    <div class="m-1" *ngIf="item.bulkPurchaseId">
                      <a class="fw-bold fs-6 me-1" href="javascript: void(0)"
                        routerLink="/retail/bulk-purchase/detail/{{ item.bulkPurchaseId }}"> Mal girişi detayına git </a>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.Collection">
                  <i [ngbPopover]="popCollection" container="body" popoverTitle="Açıklama" placement="top"
                    class="fas fa-info-circle fa-2xl" (click)="getCaseNameById(item)"></i>
                  <ng-template #popCollection>
                    <div class="m-1 fs-6">
                      <span class="fw-bold fs-6 me-1"> Müşteri: </span> <a href="javascript: void(0)"
                        routerLink="/customer/detail/{{ item.customerId }}"> {{item.customerName}} </a>
                    </div>
                    <div class="m-1" *ngIf="collectionCaseName != null">
                      <span class="fw-bold fs-6 me-1">Kasa: </span> <span> {{collectionCaseName}} </span>
                    </div>
                    <div class="m-1" *ngIf="item.description">
                      <span>{{item.description}}</span>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="item.reason == reasonEnum.Exchange">
                  <i (click)="getExchangeDetails(item.exchangeId)" [ngbPopover]="popExchange"
                    popoverClass="my-custom-class" container="body" [popoverTitle]="exchangeTitle" placement="top"
                    class="fas fa-info-circle fa-2xl"></i>
                  <ng-template #exchangeTitle><a href="javascript: void(0)"
                      routerLink="/exchange/detail/{{ item.exchangeId }}"> Alım/Satım </a></ng-template>
                  <ng-template #popExchange class="p-0">
                    <div class="d-flex justify-content-between mb-2">
                      <div>
                        <span class="me-1"> <strong>Müşteri:</strong> <a class="ms-1" href="javascript: void(0)"
                            routerLink="/customer/detail/{{ item.customerId }}">{{item.customerName}}</a> </span>
                      </div>
                      <div>
                        <span> <strong>Durum:</strong> <span class="ms-1"> {{exchangeInfo.state | exchangeState}}
                          </span></span>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                      <div>
                        <span class="me-1"> <strong>Satış:</strong> {{exchangeInfo.paymentCaseName}} </span>
                      </div>
                      <div>
                        <span class="me-1"> <strong>Alış:</strong> {{exchangeInfo.exchangeCaseName}} </span>
                      </div>
                    </div>
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th class="table-danger">Satış</th>
                          <!-- <th class="table-danger">Kasa</th> -->
                          <th class="table-info">Kur</th>
                          <th class="table-success">Alış</th>
                          <!-- <th class="table-success">Kasa</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td> {{exchangeInfo.exchangeAmount | currencyAmount: exchangeInfo.exchangeCurrency}} <span
                              class="me-1" *ngIf="exchangeInfo.exchangeSubType"> ({{ exchangeInfo.exchangeSubType |
                              subTypeDisplay }})</span> {{exchangeInfo.exchangeCurrency | customCurrency}}</td>
                          <!-- <td> {{exchangeInfo.exchangeCaseName}}</td> -->
                          <td> {{exchangeInfo.parity | currencyAmount: null: null: true}} </td>
                          <td> {{exchangeInfo.paymentAmount | currencyAmount: exchangeInfo.paymentCurrency}} <span
                              class="me-1" *ngIf="exchangeInfo.paymentSubType"> ({{ exchangeInfo.paymentSubType |
                              subTypeDisplay }})</span> {{exchangeInfo.paymentCurrency | customCurrency}} </td>
                          <!-- <td> {{exchangeInfo.paymentCaseName}}</td> -->
                        </tr>
                      </tbody>
                    </table>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="item.reason == reasonEnum.Sales">
                  <i [ngbPopover]="popSales" (click)="getSales(item.salesId)" container="body" popoverTitle="Açıklama"
                    placement="top" class="fas fa-info-circle fa-2xl"></i>
                  <ng-template #popSales>
                    <div class="m-1 fs-6" *ngIf="salesDetail && salesDetail.customerName">
                      <span class="fw-bold fs-6 me-1"> Müşteri: </span> <a href="javascript: void(0)"
                        routerLink="/customer/detail/{{ salesDetail.customerId }}"> {{salesDetail.customerName}} </a>
                    </div>
                    <div class="m-1" *ngIf="salesDetail && salesDetail.salesPrice">
                      <span class="fw-bold fs-6 me-1">Satış Fiyatı: </span> <span> {{salesDetail.salesPrice |
                        currencyAmount: null: null: true}} {{salesDetail.salesCurrency | priceCurrency:
                        salesDetail.salesSubType}} </span>
                    </div>
                    <div class="m-1" *ngIf="salesDetail && salesDetail.paidAmount">
                      <span class="fw-bold fs-6 me-1">Ödenen Miktar: </span> <span> {{salesDetail.paidAmount |
                        currencyAmount: null: null: true}} {{salesDetail.salesCurrency | priceCurrency:
                        salesDetail.salesSubType}} </span>
                    </div>
                    <div class="m-1" *ngIf="salesDetail && item.salesId">
                      <a class="fw-bold fs-6 me-1" href="javascript: void(0)"
                        routerLink="/fast-selling/detail/{{ item.salesId }}"> Detaya Git </a>
                    </div>
                  </ng-template>
                </ng-container>
                <!-- Banka hareketinden doğan sebepler (eşleşme / havale / otomatik müşteri) -->
                <ng-container *ngIf="isBankRelatedReason(item.reason)">
                  <i [ngbPopover]="popBankMatch" container="body" [popoverTitle]="item.reason | reasonType"
                    placement="top" class="fas fa-info-circle fa-2xl"></i>
                  <ng-template #popBankMatch>
                    <div class="m-1 fs-6" *ngIf="item.bankAccountId != null">
                      <span class="fw-bold fs-6 me-1"> Banka Hesabı: </span> <a href="javascript: void(0)"
                        routerLink="/bank-account/detail/{{ item.bankAccountId }}"> {{ item.bankAccountName }} </a>
                    </div>
                    <div class="m-1 fs-6" *ngIf="item.customerId != null">
                      <span class="fw-bold fs-6 me-1"> Müşteri: </span> <a href="javascript: void(0)"
                        routerLink="/customer/detail/{{ item.customerId }}"> {{ item.customerName }} </a>
                    </div>
                    <div class="m-1 fs-6" *ngIf="item.description">
                      <span class="fw-bold fs-6 me-1"> İşlem Açıklaması: </span> <span> {{ item.description }} </span>
                    </div>
                  </ng-template>
                </ng-container>
                </td>
                <td *ngIf="showSelectionField" class="text-center">
                  <input
                  class="form-check-input"
                  type="checkbox"
                  [ngModel]="selectedTransactionForReceiptIndex === index"
                  (change)="addSelections($event, item)">
                </td>
                <td *ngIf="showBalanceField" class="text-center">
                  <!-- <input class="form-check-input" type="checkbox" [(ngModel)]="item.dateSelectedForBalance" (ngModelChange)="getItemForBalance(item)"  value="1" name="checkbox" checked> -->
                  <input class="form-check-input" type="checkbox" [ngModel]="selectedIndex === index"
                    (change)="changeSelection($event, index, item)">
                </td>
                <td><span *ngIf="item.type == Type.Receivable" class="fw-bold"> + </span><span
                    *ngIf="item.type == Type.Debt" class="fw-bold"> - </span>
                  {{ item.amount | currencyAmount : item.currency : item.subType: true }}</td>
                <td>{{ item.currency | customCurrency }}
                  <span *ngIf="item.subType != undefined">({{ item.subType | subTypeDisplay }})</span>
                </td>
                <td>{{item.milyem}}</td>
                <td>{{item.caseName}} </td>
                <!-- <td innerHTML="{{ item.type | transactionType }}"></td> -->
                <td>
                  {{ item.reason | reasonType }}
                  <!-- Gelir/gider hareketinde türü (ör. "POS Komisyonu") nedenin altında -->
                  <div class="small text-muted" *ngIf="item.expenseTypeName">{{ item.expenseTypeName }}</div>
                  <div class="small text-muted fst-italic" *ngIf="!item.expenseTypeName && isIncomeExpenseReason(item.reason)">Tür seçilmedi</div>
                </td>
                <td>{{ item.date | date:'dd.MM.y HH:mm' }} </td>
                <td class="text-center"><app-history [trackable]="item"></app-history> </td>
                <td>
                    <span *ngIf="item.bankAccountId != null">
                      <i *ngIf="item.bankAccountTransactionId != null" class="fa fa-check text-success h1"></i>
                      <i *ngIf="item.bankAccountTransactionId == null" class="fa fa-times text-danger h1"></i>
                    </span>
                </td>
                <td class="text-center"> <button type="button" *hasRole="[Role.User]" class="btn btn-sm btn-danger"
                    (click)="delete(item.id)"> <i class="text-white fas fa-trash-alt"></i> </button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <app-pagination [blurOn]="Loading" [pageInfo]="model.data" [pageRequest]="request"
            (requestEvent)="reloadData()">
          </app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
